export default ({
  address_line1 = null,
  address_line2 = null,
  city = null,
  company_name = null,
  country = null,
  country_code = null,
  email = null,
  first_name = null,
  last_name = null,
  phone_number = null,
  pickup_date = null,
  postal_code = null,
  province = null,
  shipment_pickup_at = null,
  shipment_pickup_comments = null,
}) => ({
  address_line1,
  address_line2,
  city,
  company_name,
  country,
  country_code,
  email,
  first_name,
  last_name,
  phone_number,
  pickup_date,
  postal_code,
  province,
  shipment_pickup_at,
  shipment_pickup_comments,
});
